{
  "schemaVersion": 1,
  "policy": {
    "diagnosticInterpretation": "forbidden",
    "under24MonthsDefaultMode": "caregiver-mediated",
    "approvedSourceKinds": [
      "early-childhood-national-framework",
      "responsive-caregiving-protocol",
      "health-guideline"
    ],
    "approvedAgeBands": [
      "birth-1-week",
      "1-week-6-months",
      "6-9-months",
      "9-12-months",
      "12-24-months",
      "24-36-months"
    ]
  },
  "sources": [
    {
      "id": "it-mim-dm-43-2022",
      "kind": "early-childhood-national-framework",
      "authority": "Ministero dell’Istruzione",
      "title": "Orientamenti nazionali per i servizi educativi per l’infanzia",
      "reference": "D.M. 24 febbraio 2022, n. 43",
      "canonicalIdentifier": "DM 43/2022",
      "scope": "Primo riferimento unitario nazionale per i servizi educativi per l’infanzia 0–3 nel sistema integrato zerosei.",
      "url": "https://www.istruzione.it/sistema-integrato-06/orientamenti-nazionali.html"
    },
    {
      "id": "it-mim-dm-334-2021",
      "kind": "early-childhood-national-framework",
      "authority": "Ministero dell’Istruzione",
      "title": "Linee pedagogiche per il sistema integrato zerosei",
      "reference": "D.M. 22 novembre 2021, n. 334",
      "canonicalIdentifier": "DM 334/2021",
      "scope": "Cornice pedagogica nazionale per continuità educativa, gioco, esplorazione, relazioni, autonomia e molteplici linguaggi dalla nascita ai sei anni.",
      "url": "https://www.istruzione.it/sistema-integrato-06/allegati/decreto%20ministeriale%2022%20novembre%202021,%20n.%20334.pdf"
    },
    {
      "id": "who-unicef-ccd-2012",
      "kind": "responsive-caregiving-protocol",
      "authority": "World Health Organization / UNICEF",
      "title": "Care for child development: improving the care of young children",
      "reference": "WHO/UNICEF · 2012 · ISBN 9789241548403",
      "canonicalIdentifier": "WHO ISBN 9789241548403",
      "scope": "Approccio evidence-based per apprendimento precoce e responsive caregiving, con raccomandazioni operative di gioco e comunicazione suddivise per fascia d’età.",
      "url": "https://www.who.int/publications/i/item/9789241548403"
    },
    {
      "id": "who-under5-24h-2019",
      "kind": "health-guideline",
      "authority": "World Health Organization",
      "title": "Guidelines on physical activity, sedentary behaviour and sleep for children under 5 years of age",
      "reference": "WHO · 2019 · ISBN 9789241550536",
      "canonicalIdentifier": "WHO ISBN 9789241550536",
      "scope": "Guardrail sanitario per attività fisica, comportamento sedentario, sonno e tempo di schermo nella prima infanzia.",
      "url": "https://www.who.int/publications/i/item/9789241550536"
    }
  ],
  "activities": [
    {
      "activityId": "ccd.12-24.stack-safe-objects",
      "skillId": "early.play.stack-objects.12-24",
      "title": "Impilare oggetti sicuri",
      "ageBands": ["12-24-months"],
      "mode": "caregiver-mediated",
      "developmentalDomain": "Gioco, esplorazione e coordinazione",
      "objective": "Offrire al bambino un’attività di esplorazione attiva impilando oggetti semplici e sicuri, seguendo il suo interesse e il suo ritmo.",
      "sourceMappings": [
        {
          "sourceId": "who-unicef-ccd-2012",
          "locator": "Participant Manual · Recommendations · 12 months up to 2 years · PLAY · p. 18; Counselling Cards · 12 months up to 2 years · PLAY",
          "rationale": "CCD raccomanda esplicitamente di dare al bambino cose da impilare; l’app guida l’adulto e l’attività avviene con oggetti reali."
        },
        {
          "sourceId": "it-mim-dm-43-2022",
          "locator": "Orientamenti nazionali 0–3 · esperienza, gioco, esplorazione, autonomia e ambiente educativo",
          "rationale": "La modalità preserva gioco attivo, iniziativa del bambino, esplorazione concreta e sostegno dell’adulto."
        },
        {
          "sourceId": "who-under5-24h-2019",
          "locator": "Recommendations · sedentary screen time · 1-year-olds",
          "rationale": "A 1 anno il tempo sedentario davanti allo schermo non è raccomandato: il dispositivo serve solo a istruire l’adulto e va poi messo da parte."
        }
      ],
      "materials": ["2–4 oggetti grandi, leggeri, puliti e stabili, adatti all’età e non ingeribili"],
      "safetyConstraints": [
        "Supervisione continua dell’adulto.",
        "Nessun oggetto piccolo o parte staccabile che possa costituire rischio di soffocamento.",
        "Evitare oggetti appuntiti, fragili, pesanti o con bordi taglienti.",
        "Usare solo materiali appropriati allo sviluppo e alle indicazioni di sicurezza del produttore quando applicabili."
      ],
      "observationSignals": [
        "Il bambino esplora gli oggetti o prova a metterli uno sull’altro.",
        "Il bambino ripete spontaneamente l’azione o cerca una variante.",
        "Il bambino segnala interesse, pausa o desiderio di interrompere."
      ],
      "adaptation": {
        "ifEasy": "Aggiungere un solo oggetto o offrire forme leggermente diverse, senza trasformare il gioco in una prova.",
        "ifHard": "Ridurre a due oggetti e mostrare una volta l’azione; lasciare poi spazio al tentativo del bambino.",
        "stopRule": "Interrompere subito se il bambino si disinteressa, si irrita, appare stanco o il materiale non resta sicuro."
      },
      "screen": {
        "classification": "adult-coach-off-screen",
        "expectedOnScreenSeconds": 20
      },
      "diagnosticUse": "none",
      "status": "implemented"
    },
    {
      "activityId": "ccd.12-24.container-in-out",
      "skillId": "early.play.container-in-out.12-24",
      "title": "Mettere dentro e tirare fuori",
      "ageBands": ["12-24-months"],
      "mode": "caregiver-mediated",
      "developmentalDomain": "Gioco, esplorazione e coordinazione",
      "objective": "Permettere al bambino di esplorare ripetutamente il mettere oggetti in un contenitore e tirarli fuori.",
      "sourceMappings": [
        {
          "sourceId": "who-unicef-ccd-2012",
          "locator": "Participant Manual · Recommendations · 12 months up to 2 years · PLAY · p. 18; Counselling Cards · 12 months up to 2 years · PLAY",
          "rationale": "CCD raccomanda esplicitamente oggetti da mettere in contenitori e togliere; la ripetizione è descritta come parte naturale dell’apprendimento."
        },
        {
          "sourceId": "it-mim-dm-43-2022",
          "locator": "Orientamenti nazionali 0–3 · gioco, esplorazione, iniziativa e relazione educativa",
          "rationale": "L’attività è concreta, esplorativa e guidata dall’interesse del bambino, con l’adulto come supporto."
        },
        {
          "sourceId": "who-under5-24h-2019",
          "locator": "Recommendations · sedentary screen time · 1-year-olds",
          "rationale": "L’esperienza deve avvenire fuori dallo schermo; l’app mostra solo la breve consegna al caregiver."
        }
      ],
      "materials": ["Un contenitore ampio e stabile", "2–5 oggetti grandi, puliti e non ingeribili"],
      "safetyConstraints": [
        "Supervisione continua dell’adulto.",
        "Il contenitore non deve poter chiudere o intrappolare parti del corpo.",
        "Nessun oggetto piccolo o parte staccabile che possa costituire rischio di soffocamento.",
        "Evitare sacchetti, corde, contenitori fragili o materiali taglienti."
      ],
      "observationSignals": [
        "Il bambino mette o prova a mettere un oggetto nel contenitore.",
        "Il bambino tira fuori gli oggetti o ripete il ciclo dentro/fuori.",
        "Il bambino modifica il gioco secondo il proprio interesse."
      ],
      "adaptation": {
        "ifEasy": "Cambiare uno degli oggetti o la forma del contenitore mantenendo lo stesso schema di gioco.",
        "ifHard": "Usare un contenitore molto ampio e un solo oggetto; mostrare lentamente una volta.",
        "stopRule": "Interrompere se il bambino non è interessato, si irrita o qualunque materiale diventa non sicuro."
      },
      "screen": {
        "classification": "adult-coach-off-screen",
        "expectedOnScreenSeconds": 20
      },
      "diagnosticUse": "none",
      "status": "implemented"
    },
    {
      "activityId": "ccd.12-24.simple-questions-responsive-talk",
      "skillId": "early.communication.simple-questions.12-24",
      "title": "Domande semplici e risposta ai tentativi di parlare",
      "ageBands": ["12-24-months"],
      "mode": "caregiver-mediated",
      "developmentalDomain": "Comunicazione e relazione responsiva",
      "objective": "Aiutare l’adulto a creare brevi scambi comunicativi facendo domande semplici e rispondendo ai suoni, gesti o tentativi di parola del bambino.",
      "sourceMappings": [
        {
          "sourceId": "who-unicef-ccd-2012",
          "locator": "Participant Manual · Recommendations · 12 months up to 2 years · COMMUNICATE · p. 18; Counselling Cards · 12 months up to 2 years · COMMUNICATE",
          "rationale": "CCD prescrive di fare domande semplici e rispondere ai tentativi del bambino di parlare; l’attività è quindi una guida alla relazione, non un test linguistico."
        },
        {
          "sourceId": "it-mim-dm-43-2022",
          "locator": "Orientamenti nazionali 0–3 · relazioni, comunicazione, ascolto e molteplici linguaggi",
          "rationale": "L’adulto osserva e risponde ai segnali del bambino senza forzare una prestazione."
        }
      ],
      "materials": ["Nessun materiale obbligatorio; usare una situazione quotidiana o un oggetto familiare già presente"],
      "safetyConstraints": [
        "Non trasformare le domande in interrogazione o verifica.",
        "Accettare suoni, gesti, sguardi e parole come forme di risposta senza correzione punitiva.",
        "Non interpretare mancata risposta o modalità comunicative come indicazione diagnostica."
      ],
      "observationSignals": [
        "Il bambino mostra interesse con sguardo, gesto, suono o parola.",
        "L’adulto riesce ad attendere e rispondere al tentativo comunicativo.",
        "Lo scambio resta piacevole e reciproco."
      ],
      "adaptation": {
        "ifEasy": "Continuare lo scambio con una seconda domanda semplice collegata all’interesse espresso dal bambino.",
        "ifHard": "Ridurre la domanda a una scelta o commentare ciò che il bambino sta già guardando/facendo, senza richiedere risposta.",
        "stopRule": "Smettere di fare domande se il bambino distoglie l’attenzione o mostra disagio; tornare a una normale interazione affettuosa."
      },
      "screen": {
        "classification": "adult-coach-off-screen",
        "expectedOnScreenSeconds": 15
      },
      "diagnosticUse": "none",
      "status": "implemented"
    },
    {
      "activityId": "ccd.12-24.talk-about-world",
      "skillId": "early.communication.talk-about-world.12-24",
      "title": "Parlare di immagini, natura e cose",
      "ageBands": ["12-24-months"],
      "mode": "caregiver-mediated",
      "developmentalDomain": "Comunicazione, attenzione condivisa ed esplorazione",
      "objective": "Invitare l’adulto a condividere l’attenzione del bambino su una cosa reale, un’immagine o un elemento della natura e parlarne in modo semplice e responsivo.",
      "sourceMappings": [
        {
          "sourceId": "who-unicef-ccd-2012",
          "locator": "Participant Manual · Recommendations · 12 months up to 2 years · COMMUNICATE · p. 18; Counselling Cards · 12 months up to 2 years · COMMUNICATE",
          "rationale": "CCD raccomanda esplicitamente di mostrare e parlare di natura, immagini e cose."
        },
        {
          "sourceId": "it-mim-dm-43-2022",
          "locator": "Orientamenti nazionali 0–3 · esplorazione dell’ambiente, relazioni e linguaggi",
          "rationale": "L’attività parte dall’esperienza reale del bambino e sostiene comunicazione e scoperta senza schede o drill."
        }
      ],
      "materials": ["Un oggetto familiare, una fotografia/immagine semplice oppure qualcosa nell’ambiente naturale immediatamente disponibile"],
      "safetyConstraints": [
        "Preferire oggetti e ambiente reali; evitare di usare il telefono come sostituto prolungato dell’esperienza.",
        "Qualunque oggetto manipolato deve essere appropriato all’età e usato sotto supervisione.",
        "Seguire l’interesse del bambino senza forzare attenzione o denominazione."
      ],
      "observationSignals": [
        "Il bambino guarda, indica, tocca o vocalizza rispetto all’oggetto/immagine/elemento osservato.",
        "L’adulto segue l’attenzione del bambino e commenta in modo semplice.",
        "L’interazione prosegue spontaneamente oppure termina senza pressione."
      ],
      "adaptation": {
        "ifEasy": "Aggiungere un breve confronto o una seconda cosa collegata a quella scelta dal bambino.",
        "ifHard": "Usare un solo oggetto molto familiare e limitarsi a nominarlo/commentarlo seguendo lo sguardo del bambino.",
        "stopRule": "Interrompere quando il bambino cambia interesse; seguire il nuovo focus oppure concludere l’attività."
      },
      "screen": {
        "classification": "adult-coach-off-screen",
        "expectedOnScreenSeconds": 15
      },
      "diagnosticUse": "none",
      "status": "implemented"
    }
  ]
}
